// src/utils/leadHelpers.ts

export interface AssignedUser {
  id: number
  username: string
  first_name?: string
  last_name?: string
  email?: string
}

export interface Lead {
  id: number
  full_name: string
  email: string
  phone: string
  company: string
  message: string
  source: string
  status: LeadStatus
  status_display?: string
  assigned_to: number | null
  assigned_to_detail: AssignedUser | null
  notes: string
  created_at: string
  updated_at: string
}

export type LeadStatus = 'new' | 'contacted' | 'qualified' | 'converted' | 'lost'

export interface StatusOption {
  value: LeadStatus
  label: string
  color: string
  bgColor: string
  dotColor: string
}

export const STATUS_OPTIONS: StatusOption[] = [
  {
    value: 'new',
    label: 'Nuovo',
    color: 'var(--hexa-purple)',
    bgColor: 'rgba(139, 92, 246, 0.15)',
    dotColor: '#8b5cf6',
  },
  {
    value: 'contacted',
    label: 'Contattato',
    color: 'var(--hexa-text-primary)',
    bgColor: 'rgba(245, 158, 11, 0.15)',
    dotColor: '#f59e0b',
  },
  {
    value: 'qualified',
    label: 'Qualificato',
    color: 'var(--hexa-text-primary)',
    bgColor: 'rgba(34, 197, 94, 0.15)',
    dotColor: '#22c55e',
  },
  {
    value: 'converted',
    label: 'Convertito',
    color: 'var(--hexa-text-primary)',
    bgColor: 'rgba(59, 130, 246, 0.15)',
    dotColor: '#3b82f6',
  },
  {
    value: 'lost',
    label: 'Perso',
    color: 'var(--hexa-text-primary)',
    bgColor: 'rgba(239, 68, 68, 0.15)',
    dotColor: '#ef4444',
  },
]

export function getStatusBadge(status: LeadStatus): { label: string; color: string; bgColor: string; dotColor: string } {
  const option = STATUS_OPTIONS.find((opt) => opt.value === status)
  if (option) {
    return {
      label: option.label,
      color: option.color,
      bgColor: option.bgColor,
      dotColor: option.dotColor,
    }
  }
  // Fallback
  return {
    label: status,
    color: 'var(--hexa-text-secondary)',
    bgColor: 'var(--hexa-border)',
    dotColor: 'var(--hexa-text-muted)',
  }
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function formatDateTime(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
